
import HttpRequest from './axios'
const baseApi = import.meta.env.VITE_VUEBASE_URL
const axios = new HttpRequest(baseApi)
export default axios
